import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CustomHttp, ConfigServerService } from '../../../core';
import { ClassificacaoFaturamento } from '../classificacao-faturamento';

@Injectable({
    providedIn: 'root'
})
export class ClassificacaoFaturamentoAnualHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/classificacaofaturamento/0`;
    }

    /** Procura a classificação de faturamento que está dentro do range de valor inicial e final de faturamento anual através do valor informado */
    findByValorFaturamentoAnual(valorFaturamentoAnual: number): Observable<ClassificacaoFaturamento> {
        return this.customHttp.get<ClassificacaoFaturamento>(`${this.pathApi}/valorfaturamentoanual/${valorFaturamentoAnual}`);
    }
}
